import { Search } from './../../shared/user.model';
import { Component, OnInit } from '@angular/core';
import { DISABLED } from '@angular/forms/src/model';
import { Register } from '../../shared/user.model';
import { NgForm } from '@angular/forms';
//import { UserService } from '../../shared/user.service';
import { RegistrationService } from '../../registration.service';
import { Router } from '@angular/router';
import { ErrorHandler } from '../../shared/ErrorHandler';
import swal from 'sweetalert2';

@Component({
  selector: 'app-grievence-grid',
  templateUrl: './grievence-grid.component.html',
  styleUrls: ['./grievence-grid.component.css']
})
export class GrievenceGridComponent implements OnInit {
  title = "Sainik Grievances List";  
  grievances;  
  itemsPerPage: number=5;
  currentPage: number=1;
  totalItems: number;
  isSearch:boolean;
  s: Search;
  constructor(private userService: RegistrationService, private router: Router, private errorHandler:ErrorHandler)  
  { 
    this.s=new Search();
    this.isSearch = false;
  }

  ngOnInit() {
    this.GetAllGrievances(this.itemsPerPage, 1);
  }
  GetAllGrievances(itemsPerPage: number, pageNo: number) {    
    document.getElementById('loader-spinner').style.display = "block";
    debugger;
    this.userService.getAllGrievances(itemsPerPage,pageNo)
      .subscribe(
        (data:any) => {
          this.grievances=data.SainikGrievancess;          
          this.totalItems=data.TotalItemsCount;
          this.itemsPerPage = itemsPerPage;
          this.currentPage = pageNo;          
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }
  pageChanged(pageNumber:number)
  {
    if (this.s.SearchText != "" && this.s.SearchText != null && this.s.SearchCriteria != "" && this.s.SearchCriteria != null)
    {
      this.isSearch = true;
    }
    else
    {
      this.isSearch = false;
    }
    if (this.isSearch)
      this.onSearch(this.s, this.itemsPerPage, pageNumber);
    else
    this.GetAllGrievances(this.itemsPerPage, pageNumber);
  }
  itemsPerPageChanged(itemsPerPage: number, pageNo: number) 
  {
    if (this.s.SearchText != "" && this.s.SearchText != null && this.s.SearchCriteria != "" && this.s.SearchCriteria != null)
    {
      this.isSearch = true;
    }
    else
    {
      this.isSearch = false;
    }
    if (this.isSearch)
      this.onSearch(this.s, this.itemsPerPage, pageNo);
    else
      this.GetAllGrievances(this.itemsPerPage, pageNo);
  }
   //variable : holds the data from API
 // districtList;
 onSearch(s,itemsPerPage: number, pageNo: number) 
 {
   debugger;
   var searchText = this.s.SearchText;
   var searchCriteria = this.s.SearchCriteria;
   if (searchText == "" || searchText == null || searchCriteria == "" || searchCriteria == null)
     swal("Warning!", "Please enter the search criteria and search text.", "warning");
   else {
     document.getElementById('loader-spinner').style.display = "block";
     this.userService.searchGrievances(searchCriteria, searchText, itemsPerPage, pageNo)
       .subscribe(
         (data:any) => {
           debugger;
           this.grievances = data.SainikGrievancess;           
           this.totalItems = data.TotalItemsCount;           
           this.currentPage = pageNo;
           document.getElementById('loader-spinner').style.display = "none";
         }, (error:any) => {
           document.getElementById('loader-spinner').style.display = "none";
           this.errorHandler.HandlerError(error);
         });
   }
 }

}



// WEBPACK FOOTER //
// ./src/app/grievence-lodging/grievence-grid/grievence-grid.component.ts